import * as React from 'react';

export const useHoverControl = () => {
  const [ isHovered, setHovered ] = React.useState(false);
  const toggleHover = () => setHovered(!isHovered);

  return { isHovered, toggleHover, setHovered };
};
